import { render, staticRenderFns } from "./InventoryBalances.vue?vue&type=template&id=4c6550e8&scoped=true"
import script from "./InventoryBalances.vue?vue&type=script&lang=js"
export * from "./InventoryBalances.vue?vue&type=script&lang=js"
import style0 from "./InventoryBalances.vue?vue&type=style&index=0&id=4c6550e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6550e8",
  null
  
)

export default component.exports